var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.181641,
    width: 14,
    height: 14,
    rx: 7,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87005 5.76275C9.27671 5.04042 8.4125 4.57607 7.62569 4.57607C6.23263 4.57607 5.17494 5.67246 5.17494 7.1171C5.17494 8.57465 6.23263 9.68393 7.62569 9.68393C8.37381 9.68393 9.23802 9.27118 9.87005 8.62624L11.2502 10.1096C10.2828 11.1286 8.83816 11.7864 7.4967 11.7864C4.77509 11.7864 2.75 9.80002 2.75 7.1429C2.75 4.53737 4.82668 2.57678 7.58699 2.57678C8.92845 2.57678 10.3344 3.17012 11.2373 4.12462L9.87005 5.76275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLp);
export default __webpack_public_path__ + "static/media/lp.e0a157193f44bc8cb1c0792e58cb9d29.svg";
export { ForwardRef as ReactComponent };